class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M13.166 7.217c.554 0 1-.446 1-1v-3a1 1 0 0 0-1-1h-3c-.551 0-1 .449-1 1v3a1 1 0 0 0 1 1h1v2.051c-.98.2-1.749.969-1.949 1.949H7.166v-1a1 1 0 0 0-1-1h-1V7.168a2.501 2.501 0 0 0-.5-4.951 2.5 2.5 0 0 0-.5 4.951v2.049h-1c-.551 0-1 .449-1 1v3a1 1 0 0 0 1 1h3c.554 0 1-.446 1-1v-1h2.051a2.502 2.502 0 0 0 2.618 1.994 2.496 2.496 0 0 0 2.325-2.325 2.495 2.495 0 0 0-1.994-2.618V7.217h1Zm-10-2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm3 8.5h-3v-3h3v3Zm7-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-3-8.5h3v3h-3v-3Z"></path></svg>';
  }
}
const a = "pi-mod-advanced-rca";
customElements.get(a) || customElements.define(a, e);
export {
  e as default
};
